import validator from 'validator';

const isEmpty = (text) => !text || text.length === 0;

const isEmail = (email) => !!email && validator.isEmail(email);

export default { isEmpty, isEmail };
